import { ForwardedRef, MutableRefObject, useEffect, useRef, useState } from 'react';

export const useForwardedRefTransformer = <T,>(forwardedRef: ForwardedRef<T>): MutableRefObject<T | null> => {
  const ref = useRef<T | null>(null);
  const [_, setRerender] = useState(false);

  // forwarded ref can be a function, so we need to make sure that types are good, and TS does not throw an error
  if (typeof forwardedRef === 'function') {
    forwardedRef(ref.current);
  } else if (forwardedRef) {
    ref.current = forwardedRef.current;
  }

  const { current } = ref;
  const isElement = !!current;

  useEffect(() => {
    setRerender(!!ref.current);
  }, [isElement]);

  return ref;
};
